module.exports = __webpack_public_path__ + "img/storekeeper__logo.0eb0a618.svg";